"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SplitTextContainer = exports.SplitButtonArrowIcon = exports.SplitButton = exports.MenuWrapper = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _ArrowDown = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowDown16"));
var _styledIs = _interopRequireWildcard(require("styled-is"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _mixins = require("../../styles/mixins");
var _HBPopover = require("../HBPopover/HBPopover.styles");
var _HBButton = require("./HBButton.styles");
var _HBClickable = _interopRequireDefault(require("../HBClickable/HBClickable"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var splitChildrenStyle = function splitChildrenStyle(isDisabled) {
  return (0, _styledComponents.css)(["display:flex;height:100%;align-items:center;transition:inherit;cursor:pointer;", ""], !isDisabled && (0, _styledComponents.css)(["&:hover{background:", ";}"], function (props) {
    return _HBButton.buttonThemes[props.theme].hoverBackground;
  }));
};
var splitButtonPaddings = {
  system: {
    xs: {
      text: 10,
      target: 6
    },
    sm: {
      text: 12,
      target: 8
    },
    md: {
      text: 14,
      target: 10
    },
    lg: {
      text: 20,
      target: 14
    }
  },
  builder: {
    sm: {
      text: 12,
      target: 8
    },
    md: {
      text: 14,
      target: 10
    },
    xl: {
      text: 20,
      target: 14
    }
  }
};
var splitChildrenDisabledStyle = (0, _styledComponents.css)(["pointer-events:none;opacity:0.3;cursor:default;"]);
var SplitButtonArrowIcon = exports.SplitButtonArrowIcon = (0, _styledComponents["default"])(_ArrowDown["default"]).withConfig({
  displayName: "HBSplitButtonstyles__SplitButtonArrowIcon",
  componentId: "sc-21b7s8-0"
})([""]);
var SplitTextContainer = exports.SplitTextContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBSplitButtonstyles__SplitTextContainer",
  componentId: "sc-21b7s8-1"
})(["height:100%;", ""], _mixins.flexCenterAll);
var SplitButton = exports.SplitButton = (0, _styledComponents["default"])(_HBButton.Button).withConfig({
  displayName: "HBSplitButtonstyles__SplitButton",
  componentId: "sc-21b7s8-2"
})(["padding:0;cursor:default;&&:hover{background:", " !important;}", ":first-of-type{height:100%;transition:inherit;border-top-left-radius:inherit;border-bottom-left-radius:inherit;", "{", " border-top-left-radius:inherit;border-bottom-left-radius:inherit;padding:1px ", "px 0;}&:hover + ", ":last-of-type::before{", "}}", ":last-of-type{", " border-top-right-radius:inherit;border-bottom-right-radius:inherit;padding:1px ", "px 0;position:relative;margin-left:1px;&::before{left:-1px;top:0;position:absolute;content:'';height:100%;width:1px;transition:inherit;transition-property:opacity;background:", ";opacity:0.7;", " ", "}&:hover::before{opacity:1;}", " ", "}i{display:flex;}"], function (props) {
  return _HBButton.buttonThemes[props.theme].background;
}, _HBPopover.TargetContainer, SplitTextContainer, function (props) {
  return splitChildrenStyle(props.isMainButtonDisabled);
}, function (props) {
  return splitButtonPaddings[props.scope][props.size].text;
}, _HBPopover.TargetContainer, (0, _styledIs.isNot)('isMainButtonDisabled')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n                    opacity: 1;\n                "]))), _HBPopover.TargetContainer, function (props) {
  return splitChildrenStyle(props.isMenuButtonDisabled);
}, function (props) {
  return splitButtonPaddings[props.scope][props.size].target;
}, function (props) {
  return _HBButton.buttonThemes[props.theme].splitterBackground;
}, (0, _styledIs["default"])('disabled')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n                    opacity: 0;\n                "]))), (0, _styledIs["default"])('isSplitMenuOpen')(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n                    opacity: 1;\n                "]))), (0, _styledIs["default"])('isMenuButtonDisabled')(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n                ", "\n            "])), splitChildrenDisabledStyle), (0, _styledIs["default"])('isSplitMenuOpen')(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n                background: ", ";\n                ", "\n            "])), function (props) {
  return _HBButton.buttonThemes[props.theme].hoverBackground;
}, (0, _styledIs["default"])('isSplitMenuTop')(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n                    ", " {\n                        transform: rotate(180deg);\n                    }\n                "])), SplitButtonArrowIcon)));
var MenuWrapper = exports.MenuWrapper = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "HBSplitButtonstyles__MenuWrapper",
  componentId: "sc-21b7s8-3"
})(["height:100%;border-top-right-radius:inherit;transition:inherit;border-bottom-right-radius:inherit;"]);
//# sourceMappingURL=HBSplitButton.styles.js.map